var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.385 3H3.615A2.618 2.618 0 0 0 1 5.616v20.769A2.618 2.618 0 0 0 3.615 29h24.77A2.618 2.618 0 0 0 31 26.384V5.616A2.618 2.618 0 0 0 28.385 3zM29 5.616V9h-2.613l1.333-4h.664c.34 0 .616.276.616.616zM6.387 9 7.72 5h2.893L9.28 9zm6.333-4h2.893L14.28 9h-2.893zm5 0h2.893L19.28 9h-2.893zm5 0h2.893L24.28 9h-2.893zM3.615 5h1.998L4.28 9H3V5.616c0-.34.276-.616.615-.616zm24.77 22H3.615A.616.616 0 0 1 3 26.384V11h26v15.384c0 .34-.276.616-.615.616z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 24a.998.998 0 0 1-1-1v-8a1.001 1.001 0 0 1 1.525-.852l6.5 4a1.003 1.003 0 0 1-.001 1.704l-6.5 4a1.007 1.007 0 0 1-.524.148zm1-7.21v4.421L17.342 19z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.930af0d8bb095d7e4d925e75378bdc94.svg";
export { ForwardRef as ReactComponent };